/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable max-len */
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { UserStateModel } from '../../../../Core/Users/models/user-state.model';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';
import { APP_BASE_HREF } from '@angular/common';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { HubspotFormService } from '../../../../Common/Misc/services/hubspot-form.service';
import { HubspotFormTypeEnum } from '../../../../Common/Misc/enums/hubspot-form-type.enum';
import { ConfigService } from '../../../../Core/Config/services/config.service';


export interface UpsellInfoSectionListItem {
    image: string;
    heading: string;
    description: string;
    descriptionHtml?: string;
}

export enum UpsellDialogType {
    monitor = 'monitor',
    discover = 'discover',
    social = 'social'
}

const upsellDialogTypeToHubspotFormTypeEnumMap: Map<UpsellDialogType, HubspotFormTypeEnum> = new Map(
    [
        [UpsellDialogType.monitor, HubspotFormTypeEnum.MEDIA_MONITORING],
        [UpsellDialogType.discover, HubspotFormTypeEnum.MEDIA_DATABASE],
        [UpsellDialogType.social, HubspotFormTypeEnum.SOCIAL_LISTENING]
    ]
);
@Component({
    selector: 'agpr-upsell-info-dialog',
    templateUrl: 'upsell-info-dialog.component.html',
    styleUrls: ['upsell-info-dialog.component.scss'],
    standalone: false
})


export class UpsellInfoDialogComponent extends AbstractDialogComponent implements OnInit, OnDestroy {

    @Input() overlayContainer: Element;
    @Input() animationTrigger: Observable<FullProfileAnimationModel>;
    @Input() type: UpsellDialogType;

    readonly monitorImages: string[] = [
        'monitoring_intuitive',
        'monitoring_comprehensive',
        'monitoring_stay_on_top',
        'monitoring_never_miss',
        'monitoring_reporting',
    ];
    readonly discoverImages: string[] = [
        'database_powerful',
        'database_prcopilot',
        'database_build',
        'database_amplify',
        'database_monitor',
        'database_stream'
    ];
    readonly socialImages: string[] = [
        'social_find',
        'social_pictures',
        'social_insights',
        'social_reporting'
    ];


    header: string = null;
    subHeader: string;
    learnMoreMessage: string;
    infoSectionListItems: UpsellInfoSectionListItem[] = [];
    successMessage: string = null;

    isRefMediaAccount: boolean = false;

    public readonly buttonTypesEnum = ButtonTypesEnum;

    private subscriptions: Subscription[] = [];

    constructor(
        public coreDialogService: CoreDialogService,
        public currentUserStateService: CurrentUserStateService,
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        public localizationService: LocalizationService,
        public hubspotFormService: HubspotFormService,
        public configService: ConfigService
    ) {
        super(coreDialogService, 'UpsellInfoDialogComponent');
        this.isRefMediaAccount = this.configService.brandGUIDIsRefMedia();
    }

    ngOnInit() {
        this.successMessage = null;
        this.setUpsellInfoConfig();
    }

    setUpsellInfoConfig() {
        let imageList: string[];

        this.header = this.localizationService.transform(`Core.upsellInfoDialog.${this.type}.header`);
        this.subHeader = this.localizationService.transform(`Core.upsellInfoDialog.${this.type}.subHeader`);
        this.learnMoreMessage = this.localizationService.transform(`Core.upsellInfoDialog.${this.type}.learnMoreMessage`);
        switch (this.type) {
            case UpsellDialogType.monitor:
                imageList = this.monitorImages;
                break;
            case UpsellDialogType.discover:
                imageList = this.discoverImages;
                break;
            case UpsellDialogType.social:
                imageList = this.socialImages;
                break;
        }
        imageList.forEach((image, index) => {
            const item: UpsellInfoSectionListItem = {
                image: image,
                heading: this.localizationService.transform(`Core.upsellInfoDialog.${this.type}.contentItem.header${index + 1}`),
                description: this.localizationService.transform(`Core.upsellInfoDialog.${this.type}.contentItem.description${index + 1}`)
            };

            if (image === 'database_prcopilot') {
                delete item.description;
                item.descriptionHtml = this.localizationService.transform('Core.upsellInfoDialog.discover.contentItem.description2');
            }
            this.infoSectionListItems.push(item);
        });
    }

    navigateToLearnMore() {
        let url: string;

        switch(this.type){
            case UpsellDialogType.monitor:
                url = 'https://www.agilitypr.com/media-monitoring/';
                break;
            case UpsellDialogType.discover:
                url = 'https://www.agilitypr.com/media-relations/';
                break;
            case UpsellDialogType.social:
                url = 'https://www.agilitypr.com/social-media-intelligence/';
                break;
        }

        window.open(url, '_blank');
    }


    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    submitRequest() {
        if (this.isRefMediaAccount) {
            window.open('mailto:contact@refmedia.ca');
        } else {
            this.hubspotFormService.submitForm(upsellDialogTypeToHubspotFormTypeEnumMap.get(this.type)).then(done => {
                this.successMessage = this.localizationService.transform(`Core.upsellInfoDialog.${this.type}.successMessage`);
            }).catch(err => {
                this.successMessage = null;
            });
        }
    }

    cancel() {
        this.closeDialog();
    }

}
